<template>
  <div
    v-if="
      $route.name === 'login' ||
      $route.name === 'error' ||
      $route.name === 'notfound'
    "
  >
    <router-view />
  </div>

  <div v-else>
    <Menu />
    <div class="app">
      <the-header class="header" />
    </div>
    <router-view />
  </div>

</template>

<script setup lang="ts">
import Menu from "@/components/Header/Menu/Menu.vue";
import TheHeader from "@/components/Header/TheHeader.vue";
import { DialogWrapper } from "vue3-promise-dialog";

import { onMounted } from 'vue'; // Import lifecycle hooks directly from Vue
import useAutoLogout from './stores/useAutoLogout';
import { useAuthenticationStore } from "@/stores/authentication";






const logoutCallback = () => {
  // Perform logout action, such as clearing user data and redirecting
  const authenticationStore = useAuthenticationStore();
  authenticationStore.removeUser();
};

const { resetTimer } = useAutoLogout( 5 * 60 * 1000, logoutCallback); // 5 minutes in milliseconds

// Listen for user activity events
window.addEventListener('mousemove', resetTimer);
window.addEventListener('keydown', resetTimer);

// Optionally, remove the event listeners when the component is unmounted
onMounted(() => {
  const cleanup = () => {
    window.removeEventListener('mousemove', resetTimer);
    window.removeEventListener('keydown', resetTimer);
  };
  return cleanup;
});

console.log("version:pro-v1.3.2-aplha2")

</script>

<style Lang="scss">
.header {
  position: fixed;
  background: white;
  z-index: 2;
  left: 0;
  top: 0;
}

.app {
  display: flex;
  height: 55px;
  /* main {
    flex: 1 1 0;
    padding: 2rem;
    @media (max-width: 1024px) {
      padding-left: 6rem;
    }
  } */
}
</style>
